// AUTO-GENERATED: 2025-10-28T19:10:34.721034Z
// ✨ Fusion recipes

export const fusionRecipes = [
{
    name: "Korean Tacos",
    cuisine: "Fusion",
    ingredients: ["beef", "kimchi", "lettuce", "cilantro", "flour tortillas"],
    sauces: ["gochujang", "sesame oil", "lime juice", "sriracha mayo"],
    instructions: "Marinate beef in gochujang, soy sauce, sesame oil. Grill until charred. Warm tortillas. Fill with beef, kimchi, shredded lettuce, cilantro. Drizzle with sriracha mayo and sesame seeds. Squeeze lime over top. The fusion combines Korean BBQ flavors with Mexican taco format for a perfect blend of spicy, tangy, and savory.",
    time: "25 min",
    difficulty: "Easy",
    points: 75,
    servings: 2,
    special: true
  },
{
    name: "Ramen Burger",
    cuisine: "Fusion",
    ingredients: ["ground beef", "ramen noodles", "eggs", "lettuce", "tomato"],
    sauces: ["soy sauce", "sriracha", "mayonnaise", "sesame oil"],
    instructions: "Cook ramen, drain, mix with eggs and sesame oil. Form into 2 patty shapes, pan-fry until crispy on both sides to create 'buns'. Form beef patties, grill to desired doneness. Assemble: ramen bun, lettuce, tomato, beef patty, sriracha mayo, top ramen bun. This Japanese-American fusion is quirky and delicious.",
    time: "30 min",
    difficulty: "Medium",
    points: 75,
    servings: 2,
    special: true
  },
{
    name: "Sushi Burrito",
    cuisine: "Fusion",
    ingredients: ["sushi rice", "salmon", "avocado", "cucumber", "seaweed", "lettuce"],
    sauces: ["soy sauce", "wasabi mayo", "eel sauce", "sriracha"],
    instructions: "Lay large nori sheet. Spread sushi rice. Add strips of raw salmon (sushi-grade), avocado, cucumber, lettuce in a line. Add wasabi mayo and eel sauce. Roll tightly like a burrito, wrap in paper. Slice in half. This California-Japanese fusion makes sushi portable and filling like a burrito.",
    time: "20 min",
    difficulty: "Medium",
    points: 75,
    servings: 2,
    special: true
  },
{
    name: "Butter Chicken Pizza",
    cuisine: "Fusion",
    ingredients: ["pizza dough", "chicken breast", "mozzarella cheese", "onion", "cilantro"],
    sauces: ["butter chicken sauce", "naan-style crust"],
    instructions: "Grill chicken pieces in tandoori spices. Roll pizza dough, brush with garlic butter. Spread butter chicken sauce instead of tomato sauce. Add shredded chicken, mozzarella, red onions. Bake at 500°F for 10-12 minutes. Garnish with cilantro. This Indian-Italian fusion brings curry house flavors to pizza night.",
    time: "35 min",
    difficulty: "Medium",
    points: 100,
    servings: 2,
    special: true
  },
{
    name: "Pad Thai Pizza",
    cuisine: "Fusion",
    ingredients: ["pizza dough", "shrimp", "bean sprouts", "peanuts", "mozzarella cheese"],
    sauces: ["pad thai sauce", "tamarind", "peanut sauce", "lime"],
    instructions: "Par-bake pizza crust 5 minutes. Top with thin layer of pad thai sauce. Add cooked shrimp, bean sprouts, mozzarella. Bake until cheese melts. Top with crushed peanuts, cilantro, lime wedges. Drizzle with peanut sauce. This Thai-Italian fusion brings Southeast Asian street food to pizza form.",
    time: "30 min",
    difficulty: "Medium",
    points: 100,
    servings: 2,
    special: true
  },
{
    name: "Kimchi Quesadilla",
    cuisine: "Fusion",
    ingredients: ["flour tortillas", "kimchi", "cheddar cheese", "mozzarella cheese", "pork belly"],
    sauces: ["gochujang", "sour cream", "sesame oil"],
    instructions: "Cook pork belly until crispy, dice. Mix cheeses. Place tortilla in pan, add cheese, kimchi, pork. Top with second tortilla. Cook until golden and cheese melts. Cut into wedges. Serve with gochujang-sour cream sauce. This Korean-Mexican fusion delivers funky, spicy, cheesy goodness.",
    time: "15 min",
    difficulty: "Easy",
    points: 50,
    servings: 2,
    special: true
  },
{
    name: "Teriyaki Burger",
    cuisine: "Fusion",
    ingredients: ["ground beef", "pineapple", "lettuce", "burger buns"],
    sauces: ["teriyaki sauce", "mayonnaise", "sesame seeds"],
    instructions: "Form beef patties, grill. Grill pineapple slices until caramelized. Toast buns. Brush cooked burgers with teriyaki sauce. Assemble: bun, lettuce, teriyaki burger, grilled pineapple, teriyaki mayo, sesame seeds, bun. This Japanese-American fusion brings Hawaiian-style teriyaki to burgers.",
    time: "25 min",
    difficulty: "Easy",
    points: 50,
    servings: 2,
    special: true
  },
{
    name: "Banh Mi Pizza",
    cuisine: "Fusion",
    ingredients: ["pizza dough", "pork belly", "pickled vegetables", "cilantro", "jalape\u00f1os"],
    sauces: ["sriracha mayo", "hoisin sauce", "fish sauce"],
    instructions: "Par-bake crust. Mix hoisin and fish sauce, spread on crust. Add roasted pork belly, mozzarella. Bake until cheese melts. Top with pickled carrots and daikon, jalapeños, cilantro, cucumber. Drizzle with sriracha mayo. This Vietnamese-Italian fusion transforms the classic banh mi sandwich into pizza form.",
    time: "35 min",
    difficulty: "Medium",
    points: 100,
    servings: 2,
    special: true
  },
{
    name: "Curry Pasta",
    cuisine: "Fusion",
    ingredients: ["pasta", "chicken breast", "bell peppers", "onion", "parmesan cheese"],
    sauces: ["curry powder", "coconut milk", "cream", "garlic"],
    instructions: "Cook pasta. Sauté chicken with curry powder. Add bell peppers, onions. Add coconut milk and cream. Simmer 5 minutes. Toss with cooked pasta. Add parmesan. The Indian spices blend surprisingly well with Italian pasta for a creamy, aromatic fusion dish.",
    time: "25 min",
    difficulty: "Easy",
    points: 50,
    servings: 2,
    special: true
  },
{
    name: "Miso Carbonara",
    cuisine: "Fusion",
    ingredients: ["spaghetti", "bacon", "eggs", "parmesan cheese"],
    sauces: ["white miso paste", "black pepper", "butter"],
    instructions: "Cook spaghetti. Fry bacon until crispy. Beat eggs with parmesan and miso paste. Toss hot pasta with bacon, remove from heat. Quickly add egg mixture, tossing with pasta water to create creamy sauce. The miso adds umami depth to classic carbonara. Top with black pepper and more parmesan. Japanese-Italian fusion magic.",
    time: "20 min",
    difficulty: "Medium",
    points: 75,
    servings: 2,
    special: true
  },
{
    name: "Pho Ramen",
    cuisine: "Fusion",
    ingredients: ["ramen noodles", "beef", "bean sprouts", "basil", "cilantro", "lime"],
    sauces: ["star anise", "fish sauce", "soy sauce", "hoisin sauce"],
    instructions: "Simmer beef broth with star anise and ginger for 20 minutes. Cook ramen noodles separately. Slice beef thinly. Blanch bean sprouts briefly. Assemble bowls with noodles and beef. Pour hot broth over everything. Top with fresh basil, cilantro, and lime wedges. Serve with hoisin and sriracha on the side. This Vietnamese-Japanese fusion combines pho aromatics with ramen convenience.",
    time: "40 min",
    difficulty: "Medium",
    points: 100,
    servings: 2,
    special: true
  },
{
    name: "Pad Thai Pasta",
    cuisine: "Fusion",
    ingredients: ["linguine", "shrimp", "eggs", "bean sprouts", "peanuts", "scallions"],
    sauces: ["tamarind paste", "fish sauce", "sugar", "lime juice", "chili flakes"],
    instructions: "Cook linguine al dente. Mix tamarind, fish sauce, and sugar for sauce. Heat wok, stir-fry shrimp until pink. Push aside, scramble eggs. Add drained pasta and sauce, toss quickly. Add bean sprouts, cook 1 minute. Top with crushed peanuts, scallions, lime wedges, and chili flakes. This Thai-Italian fusion brings pad thai flavors to pasta.",
    time: "25 min",
    difficulty: "Easy",
    points: 50,
    servings: 2,
    special: true
  }
];
